// Product names are stored as rich text (e.g. "<p>ES 250 ...&nbsp;</p>").
// Strip tags and decode entities so only clean text shows in lists/tables.
export const stripHtml = (html) => {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
};
